
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 4.5a.5.5 0 01-1 0V1.708L6.854 5.854a.5.5 0 11-.707-.708L10.293 1H7.5a.5.5 0 110-1h4a.5.5 0 01.5.5v4zM9.5 6a.5.5 0 00-.5.5V11H1V3h4.5a.5.5 0 100-1H1a1 1 0 00-1 1v8a1 1 0 001 1h8a1 1 0 001-1V6.5a.5.5 0 00-.5-.5z","fill":"#348EF6"}})])
          )
        }
      }
    